import { Builder } from '@builder.io/react'
import TodaysTopPicks from '../../TodaysTopPicks'

Builder.registerComponent(TodaysTopPicks, {
  name: 'LBTodaysTopPicks',
  inputs: [{ name: 'title', type: 'text' }],
  image: 'https://tabler-icons.io/static/tabler-icons/icons-png/check.png'
})
